import { features } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4 whitespace-nowrap">
            为什么选择韩漫网
          </span>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950">平台特色</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((item) => (
            <div key={item.id} className="p-5 rounded-lg bg-background-100 border border-background-200/70">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 text-lg mb-4">
                <i className={item.icon}></i>
              </div>
              <h3 className="text-sm md:text-base font-heading text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}

          <div className="sm:col-span-2 lg:col-span-3 p-5 rounded-lg bg-accent-100/50 border border-accent-200/50 text-center">
            <p className="text-sm text-accent-700 font-medium">
              以上五大特色，让韩漫网成为韩漫大全爱好者最信赖的阅读推荐平台。每日更新，品质保障，追更不迷路。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}